type Props = {
  tag: string;
  title: string;
  subtitle?: string;
};

/** Shared tag-pill + title + optional subtitle block used by every landing
 * section header. Theme-aware (light/dark). */
export function SectionHeading({ tag, title, subtitle }: Props) {
  return (
    <div className="text-center mb-12">
      <span className="inline-flex rounded-full bg-slate-100 px-3 py-1 text-xs text-slate-600 ring-1 ring-slate-200 dark:bg-white/5 dark:text-slate-300 dark:ring-white/10">
        {tag}
      </span>
      <h2 className="mt-4 text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 dark:text-white">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-2 max-w-2xl mx-auto text-slate-600 dark:text-slate-400">{subtitle}</p>
      )}
    </div>
  );
}
